<template>
    <ItemCard :title="inspection.checklist_title">
        <div class="badge state-good">{{ $t("Done") }}</div>
        <p class="badge-explanation">{{ $t('on {date}', {date: $du(inspection.conducted_at, 'shortDateTime')}) }}</p>
    </ItemCard>
</template>

<script>
import ItemCard from '@mobile/components/ItemCard.vue';

export default {

    components: { ItemCard },

    props: {
        inspection: {
            type: Object,
            required: true,
        },
    },

};
</script>
